import { html } from 'lit-html'
import store from 'store2'
import openWindow from '../../../util/open_window'
import { url } from '@polleverywhere/core/lib/util'
import { cutlassEvent } from '@polleverywhere/cutlass'
import '@polleverywhere/pe-button'

export function handleGetStarted (el, state) {
  cutlassEvent(el, 'cta:become-presenter')
  openWindow(url('signup?user[role]=presenter&rtm_source=participant-home-cta&usrc=home_become_presenter'), state)
}

export function isOkToShowBecomePresenterCta (state) {
  if (!store.get('show_become_presener_cta')) {
    return false
  }

  // For some reason, logged out users can have their role set to presenter.
  if (state.get('user')?.isLoggedIn() && ['presenter', 'account owner'].includes(state.get('user')?.get('role'))) {
    return false
  }

  return true
}

export function becomePresenterBanner (el, state) {
  return html`<div class="pollev-home__banner pollev-home__banner--pwa">
    <p>Add Poll Everywhere to your presentation!<br>Gather audience feedback in an instant.</p>
    <pe-button @click=${() => handleGetStarted(el, state)} label="Create now" theme=white></pe-button>
  </div>`
}
